import Vue from 'vue'
import App from './App.vue'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueForm from 'vue-form'
import VueMeta from 'vue-meta'
import VueGtag from "vue-gtag";

import './styles.scss'
import './registerServiceWorker'

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(VueAxios, axios)
Vue.use(VueForm, {
  inputClasses: {
    valid: 'is-valid',
    invalid: 'is-invalid'
  }
})
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
})

Vue.use(VueGtag, {
  appName: 'Budapest Escort Girl Vue',
  pageTrackerEnabled: true,
  config: {
    id: "G-PNL8YJXVWC",
    params: {
      send_page_view: true
    }
  }
});

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
